import { commonjsGlobal as x, getDefaultExportFromCjs as Je } from "./composables-BbJ4etOy.js";
var Te = { exports: {} }, Oe;
function Ye() {
  return Oe || (Oe = 1, function(Se) {
    /**
     * {@link https://github.com/muaz-khan/RecordRTC|RecordRTC} is a WebRTC JavaScript library for audio/video as well as screen activity recording. It supports Chrome, Firefox, Opera, Android, and Microsoft Edge. Platforms: Linux, Mac and Windows. 
     * @summary Record audio, video or screen inside the browser.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef RecordRTC
     * @class
     * @example
     * var recorder = RecordRTC(mediaStream or [arrayOfMediaStream], {
     *     type: 'video', // audio or video or gif or canvas
     *     recorderType: MediaStreamRecorder || CanvasRecorder || StereoAudioRecorder || Etc
     * });
     * recorder.startRecording();
     * @see For further information:
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
     * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, desiredSampRate: 16000, video: HTMLVideoElement, etc.}
     */
    function R(i, e) {
      if (!i)
        throw "First parameter is required.";
      e = e || {
        type: "video"
      }, e = new ke(i, e);
      var t = this;
      function a(o) {
        return e.disableLogs || console.log("RecordRTC version: ", t.version), o && (e = new ke(i, o)), e.disableLogs || console.log("started recording " + e.type + " stream."), l ? (l.clearRecordedData(), l.record(), g("recording"), t.recordingDuration && c(), t) : (s(function() {
          t.recordingDuration && c();
        }), t);
      }
      function s(o) {
        o && (e.initCallback = function() {
          o(), o = e.initCallback = null;
        });
        var v = new Ee(i, e);
        l = new v(i, e), l.record(), g("recording"), e.disableLogs || console.log("Initialized recorderType:", l.constructor.name, "for output-type:", e.type);
      }
      function d(o) {
        if (o = o || function() {
        }, !l) {
          m();
          return;
        }
        if (t.state === "paused") {
          t.resumeRecording(), setTimeout(function() {
            d(o);
          }, 1);
          return;
        }
        t.state !== "recording" && !e.disableLogs && console.warn('Recording state should be: "recording", however current state is: ', t.state), e.disableLogs || console.log("Stopped recording " + e.type + " stream."), e.type !== "gif" ? l.stop(v) : (l.stop(), v()), g("stopped");
        function v(C) {
          if (!l) {
            typeof o.call == "function" ? o.call(t, "") : o("");
            return;
          }
          Object.keys(l).forEach(function(w) {
            typeof l[w] != "function" && (t[w] = l[w]);
          });
          var n = l.blob;
          if (!n)
            if (C)
              l.blob = n = C;
            else
              throw "Recording failed.";
          if (n && !e.disableLogs && console.log(n.type, "->", ge(n.size)), o) {
            var u;
            try {
              u = B.createObjectURL(n);
            } catch {
            }
            typeof o.call == "function" ? o.call(t, u) : o(u);
          }
          e.autoWriteToDisk && b(function(w) {
            var y = {};
            y[e.type + "Blob"] = w, q.Store(y);
          });
        }
      }
      function f() {
        if (!l) {
          m();
          return;
        }
        if (t.state !== "recording") {
          e.disableLogs || console.warn("Unable to pause the recording. Recording state: ", t.state);
          return;
        }
        g("paused"), l.pause(), e.disableLogs || console.log("Paused recording.");
      }
      function r() {
        if (!l) {
          m();
          return;
        }
        if (t.state !== "paused") {
          e.disableLogs || console.warn("Unable to resume the recording. Recording state: ", t.state);
          return;
        }
        g("recording"), l.resume(), e.disableLogs || console.log("Resumed recording.");
      }
      function h(o) {
        postMessage(new FileReaderSync().readAsDataURL(o));
      }
      function b(o, v) {
        if (!o)
          throw "Pass a callback function over getDataURL.";
        var C = v ? v.blob : (l || {}).blob;
        if (!C) {
          e.disableLogs || console.warn("Blob encoder did not finish its job yet."), setTimeout(function() {
            b(o, v);
          }, 1e3);
          return;
        }
        if (typeof Worker < "u" && !navigator.mozGetUserMedia) {
          var n = w(h);
          n.onmessage = function(y) {
            o(y.data);
          }, n.postMessage(C);
        } else {
          var u = new FileReader();
          u.readAsDataURL(C), u.onload = function(y) {
            o(y.target.result);
          };
        }
        function w(y) {
          try {
            var L = B.createObjectURL(new Blob([
              y.toString(),
              "this.onmessage =  function (eee) {" + y.name + "(eee.data);}"
            ], {
              type: "application/javascript"
            })), S = new Worker(L);
            return B.revokeObjectURL(L), S;
          } catch {
          }
        }
      }
      function c(o) {
        if (o = o || 0, t.state === "paused") {
          setTimeout(function() {
            c(o);
          }, 1e3);
          return;
        }
        if (t.state !== "stopped") {
          if (o >= t.recordingDuration) {
            d(t.onRecordingStopped);
            return;
          }
          o += 1e3, setTimeout(function() {
            c(o);
          }, 1e3);
        }
      }
      function g(o) {
        t && (t.state = o, typeof t.onStateChanged.call == "function" ? t.onStateChanged.call(t, o) : t.onStateChanged(o));
      }
      var p = 'It seems that recorder is destroyed or "startRecording" is not invoked for ' + e.type + " recorder.";
      function m() {
        e.disableLogs !== !0 && console.warn(p);
      }
      var l, T = {
        /**
         * This method starts the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var recorder = RecordRTC(mediaStream, {
         *     type: 'video'
         * });
         * recorder.startRecording();
         */
        startRecording: a,
        /**
         * This method stops the recording. It is strongly recommended to get "blob" or "URI" inside the callback to make sure all recorders finished their job.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     // use either "this" or "recorder" object; both are identical
         *     video.src = this.toURL();
         *     var blob = this.getBlob();
         * });
         */
        stopRecording: d,
        /**
         * This method pauses the recording. You can resume recording using "resumeRecording" method.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Firefox is unable to pause the recording. Fix it.
         * @example
         * recorder.pauseRecording();  // pause the recording
         * recorder.resumeRecording(); // resume again
         */
        pauseRecording: f,
        /**
         * This method resumes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.pauseRecording();  // first of all, pause the recording
         * recorder.resumeRecording(); // now resume it
         */
        resumeRecording: r,
        /**
         * This method initializes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * recorder.initRecorder();
         */
        initRecorder: s,
        /**
         * Ask RecordRTC to auto-stop the recording after 5 minutes.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var fiveMinutes = 5 * 1000 * 60;
         * recorder.setRecordingDuration(fiveMinutes, function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         * 
         * // or otherwise
         * recorder.setRecordingDuration(fiveMinutes).onRecordingStopped(function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         */
        setRecordingDuration: function(o, v) {
          if (typeof o > "u")
            throw "recordingDuration is required.";
          if (typeof o != "number")
            throw "recordingDuration must be a number.";
          return t.recordingDuration = o, t.onRecordingStopped = v || function() {
          }, {
            onRecordingStopped: function(C) {
              t.onRecordingStopped = C;
            }
          };
        },
        /**
         * This method can be used to clear/reset all the recorded data.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Figure out the difference between "reset" and "clearRecordedData" methods.
         * @example
         * recorder.clearRecordedData();
         */
        clearRecordedData: function() {
          if (!l) {
            m();
            return;
          }
          l.clearRecordedData(), e.disableLogs || console.log("Cleared old recorded data.");
        },
        /**
         * Get the recorded blob. Use this method inside the "stopRecording" callback.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.getBlob();
         *
         *     var file = new File([blob], 'filename.webm', {
         *         type: 'video/webm'
         *     });
         *
         *     var formData = new FormData();
         *     formData.append('file', file); // upload "File" object rather than a "Blob"
         *     uploadToServer(formData);
         * });
         * @returns {Blob} Returns recorded data as "Blob" object.
         */
        getBlob: function() {
          if (!l) {
            m();
            return;
          }
          return l.blob;
        },
        /**
         * Get data-URI instead of Blob.
         * @param {function} callback - Callback to get the Data-URI.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     recorder.getDataURL(function(dataURI) {
         *         video.src = dataURI;
         *     });
         * });
         */
        getDataURL: b,
        /**
         * Get virtual/temporary URL. Usage of this URL is limited to current tab.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     video.src = this.toURL();
         * });
         * @returns {String} Returns a virtual/temporary URL for the recorded "Blob".
         */
        toURL: function() {
          if (!l) {
            m();
            return;
          }
          return B.createObjectURL(l.blob);
        },
        /**
         * Get internal recording object (i.e. internal module) e.g. MutliStreamRecorder, MediaStreamRecorder, StereoAudioRecorder or WhammyRecorder etc.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var internalRecorder = recorder.getInternalRecorder();
         * if(internalRecorder instanceof MultiStreamRecorder) {
         *     internalRecorder.addStreams([newAudioStream]);
         *     internalRecorder.resetVideoStreams([screenStream]);
         * }
         * @returns {Object} Returns internal recording object.
         */
        getInternalRecorder: function() {
          return l;
        },
        /**
         * Invoke save-as dialog to save the recorded blob into your disk.
         * @param {string} fileName - Set your own file name.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     this.save('file-name');
         *
         *     // or manually:
         *     invokeSaveAsDialog(this.getBlob(), 'filename.webm');
         * });
         */
        save: function(o) {
          if (!l) {
            m();
            return;
          }
          Ae(l.blob, o);
        },
        /**
         * This method gets a blob from indexed-DB storage.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.getFromDisk(function(dataURL) {
         *     video.src = dataURL;
         * });
         */
        getFromDisk: function(o) {
          if (!l) {
            m();
            return;
          }
          R.getFromDisk(e.type, o);
        },
        /**
         * This method appends an array of webp images to the recorded video-blob. It takes an "array" object.
         * @type {Array.<Array>}
         * @param {Array} arrayOfWebPImages - Array of webp images.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * var arrayOfWebPImages = [];
         * arrayOfWebPImages.push({
         *     duration: index,
         *     image: 'data:image/webp;base64,...'
         * });
         * recorder.setAdvertisementArray(arrayOfWebPImages);
         */
        setAdvertisementArray: function(o) {
          e.advertisement = [];
          for (var v = o.length, C = 0; C < v; C++)
            e.advertisement.push({
              duration: C,
              image: o[C]
            });
        },
        /**
         * It is equivalent to <code class="str">"recorder.getBlob()"</code> method. Usage of "getBlob" is recommended, though.
         * @property {Blob} blob - Recorded Blob can be accessed using this property.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.blob;
         *
         *     // below one is recommended
         *     var blob = this.getBlob();
         * });
         */
        blob: null,
        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} bufferSize - Buffer-size used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used this buffer-size: ' + this.bufferSize);
         * });
         */
        bufferSize: 0,
        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} sampleRate - Sample-rates used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used these sample-rates: ' + this.sampleRate);
         * });
         */
        sampleRate: 0,
        /**
         * {recorderType:StereoAudioRecorder} returns ArrayBuffer object.
         * @property {ArrayBuffer} buffer - Audio ArrayBuffer, supported only in Chrome.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var arrayBuffer = this.buffer;
         *     alert(arrayBuffer.byteLength);
         * });
         */
        buffer: null,
        /**
         * This method resets the recorder. So that you can reuse single recorder instance many times.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.reset();
         * recorder.startRecording();
         */
        reset: function() {
          t.state === "recording" && !e.disableLogs && console.warn("Stop an active recorder."), l && typeof l.clearRecordedData == "function" && l.clearRecordedData(), l = null, g("inactive"), t.blob = null;
        },
        /**
         * This method is called whenever recorder's state changes. Use this as an "event".
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.onStateChanged = function(state) {
         *     console.log('Recorder state: ', state);
         * };
         */
        onStateChanged: function(o) {
          e.disableLogs || console.log("Recorder state changed:", o);
        },
        /**
         * A recorder can have inactive, recording, paused or stopped states.
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * // this looper function will keep you updated about the recorder's states.
         * (function looper() {
         *     document.querySelector('h1').innerHTML = 'Recorder\'s state is: ' + recorder.state;
         *     if(recorder.state === 'stopped') return; // ignore+stop
         *     setTimeout(looper, 1000); // update after every 3-seconds
         * })();
         * recorder.startRecording();
         */
        state: "inactive",
        /**
         * Get recorder's readonly state.
         * @method
         * @memberof RecordRTC
         * @example
         * var state = recorder.getState();
         * @returns {String} Returns recording state.
         */
        getState: function() {
          return t.state;
        },
        /**
         * Destroy RecordRTC instance. Clear all recorders and objects.
         * @method
         * @memberof RecordRTC
         * @example
         * recorder.destroy();
         */
        destroy: function() {
          var o = e.disableLogs;
          e = {
            disableLogs: !0
          }, t.reset(), g("destroyed"), T = t = null, te.AudioContextConstructor && (te.AudioContextConstructor.close(), te.AudioContextConstructor = null), e.disableLogs = o, e.disableLogs || console.log("RecordRTC is destroyed.");
        },
        /**
         * RecordRTC version number
         * @property {String} version - Release version number.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * alert(recorder.version);
         */
        version: "5.6.2"
      };
      if (!this)
        return t = T, T;
      for (var k in T)
        this[k] = T[k];
      return t = this, T;
    }
    R.version = "5.6.2", Se.exports = R, R.getFromDisk = function(i, e) {
      if (!e)
        throw "callback is mandatory.";
      console.log("Getting recorded " + (i === "all" ? "blobs" : i + " blob ") + " from disk!"), q.Fetch(function(t, a) {
        i !== "all" && a === i + "Blob" && e && e(t), i === "all" && e && e(t, a.replace("Blob", ""));
      });
    }, R.writeToDisk = function(i) {
      console.log("Writing recorded blob(s) to disk!"), i = i || {}, i.audio && i.video && i.gif ? i.audio.getDataURL(function(e) {
        i.video.getDataURL(function(t) {
          i.gif.getDataURL(function(a) {
            q.Store({
              audioBlob: e,
              videoBlob: t,
              gifBlob: a
            });
          });
        });
      }) : i.audio && i.video ? i.audio.getDataURL(function(e) {
        i.video.getDataURL(function(t) {
          q.Store({
            audioBlob: e,
            videoBlob: t
          });
        });
      }) : i.audio && i.gif ? i.audio.getDataURL(function(e) {
        i.gif.getDataURL(function(t) {
          q.Store({
            audioBlob: e,
            gifBlob: t
          });
        });
      }) : i.video && i.gif ? i.video.getDataURL(function(e) {
        i.gif.getDataURL(function(t) {
          q.Store({
            videoBlob: e,
            gifBlob: t
          });
        });
      }) : i.audio ? i.audio.getDataURL(function(e) {
        q.Store({
          audioBlob: e
        });
      }) : i.video ? i.video.getDataURL(function(e) {
        q.Store({
          videoBlob: e
        });
      }) : i.gif && i.gif.getDataURL(function(e) {
        q.Store({
          gifBlob: e
        });
      });
    };
    /**
     * {@link RecordRTCConfiguration} is an inner/private helper for {@link RecordRTC}.
     * @summary It configures the 2nd parameter passed over {@link RecordRTC} and returns a valid "config" object.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef RecordRTCConfiguration
     * @class
     * @example
     * var options = RecordRTCConfiguration(mediaStream, options);
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, getNativeBlob:true, etc.}
     */
    function ke(i, e) {
      return !e.recorderType && !e.type && (e.audio && e.video ? e.type = "video" : e.audio && !e.video && (e.type = "audio")), e.recorderType && !e.type && (e.recorderType === fe || e.recorderType === ue || typeof re < "u" && e.recorderType === re ? e.type = "video" : e.recorderType === ce ? e.type = "gif" : e.recorderType === se ? e.type = "audio" : e.recorderType === P && (A(i, "audio").length && A(i, "video").length || !A(i, "audio").length && A(i, "video").length ? e.type = "video" : A(i, "audio").length && !A(i, "video").length && (e.type = "audio"))), typeof P < "u" && typeof MediaRecorder < "u" && "requestData" in MediaRecorder.prototype && (e.mimeType || (e.mimeType = "video/webm"), e.type || (e.type = e.mimeType.split("/")[0]), e.bitsPerSecond), e.type || (e.mimeType && (e.type = e.mimeType.split("/")[0]), e.type || (e.type = "audio")), e;
    }
    /**
     * {@link GetRecorderType} is an inner/private helper for {@link RecordRTC}.
     * @summary It returns best recorder-type available for your browser.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef GetRecorderType
     * @class
     * @example
     * var RecorderType = GetRecorderType(options);
     * var recorder = new RecorderType(options);
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
     */
    function Ee(i, e) {
      var t;
      return (X || ve || ae) && (t = se), typeof MediaRecorder < "u" && "requestData" in MediaRecorder.prototype && !X && (t = P), e.type === "video" && (X || ae) && (t = fe, typeof re < "u" && typeof ReadableStream < "u" && (t = re)), e.type === "gif" && (t = ce), e.type === "canvas" && (t = ue), _() && t !== ue && t !== ce && typeof MediaRecorder < "u" && "requestData" in MediaRecorder.prototype && (A(i, "video").length || A(i, "audio").length) && (e.type === "audio" ? typeof MediaRecorder.isTypeSupported == "function" && MediaRecorder.isTypeSupported("audio/webm") && (t = P) : typeof MediaRecorder.isTypeSupported == "function" && MediaRecorder.isTypeSupported("video/webm") && (t = P)), i instanceof Array && i.length && (t = Ue), e.recorderType && (t = e.recorderType), !e.disableLogs && t && t.name && console.log("Using recorderType:", t.name || t.constructor.name), !t && de && (t = P), t;
    }
    /**
     * MRecordRTC runs on top of {@link RecordRTC} to bring multiple recordings in a single place, by providing simple API.
     * @summary MRecordRTC stands for "Multiple-RecordRTC".
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef MRecordRTC
     * @class
     * @example
     * var recorder = new MRecordRTC();
     * recorder.addStream(MediaStream);
     * recorder.mediaType = {
     *     audio: true, // or StereoAudioRecorder or MediaStreamRecorder
     *     video: true, // or WhammyRecorder or MediaStreamRecorder or WebAssemblyRecorder or CanvasRecorder
     *     gif: true    // or GifRecorder
     * };
     * // mimeType is optional and should be set only in advance cases.
     * recorder.mimeType = {
     *     audio: 'audio/wav',
     *     video: 'video/webm',
     *     gif:   'image/gif'
     * };
     * recorder.startRecording();
     * @see For further information:
     * @see {@link https://github.com/muaz-khan/RecordRTC/tree/master/MRecordRTC|MRecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @requires {@link RecordRTC}
     */
    function me(i) {
      this.addStream = function(e) {
        e && (i = e);
      }, this.mediaType = {
        audio: !0,
        video: !0
      }, this.startRecording = function() {
        var e = this.mediaType, t, a = this.mimeType || {
          audio: null,
          video: null,
          gif: null
        };
        if (typeof e.audio != "function" && _() && !A(i, "audio").length && (e.audio = !1), typeof e.video != "function" && _() && !A(i, "video").length && (e.video = !1), typeof e.gif != "function" && _() && !A(i, "video").length && (e.gif = !1), !e.audio && !e.video && !e.gif)
          throw "MediaStream must have either audio or video tracks.";
        if (e.audio && (t = null, typeof e.audio == "function" && (t = e.audio), this.audioRecorder = new R(i, {
          type: "audio",
          bufferSize: this.bufferSize,
          sampleRate: this.sampleRate,
          numberOfAudioChannels: this.numberOfAudioChannels || 2,
          disableLogs: this.disableLogs,
          recorderType: t,
          mimeType: a.audio,
          timeSlice: this.timeSlice,
          onTimeStamp: this.onTimeStamp
        }), e.video || this.audioRecorder.startRecording()), e.video) {
          t = null, typeof e.video == "function" && (t = e.video);
          var s = i;
          if (_() && e.audio && typeof e.audio == "function") {
            var d = A(i, "video")[0];
            xe ? (s = new V(), s.addTrack(d), t && t === fe && (t = P)) : (s = new V(), s.addTrack(d));
          }
          this.videoRecorder = new R(s, {
            type: "video",
            video: this.video,
            canvas: this.canvas,
            frameInterval: this.frameInterval || 10,
            disableLogs: this.disableLogs,
            recorderType: t,
            mimeType: a.video,
            timeSlice: this.timeSlice,
            onTimeStamp: this.onTimeStamp,
            workerPath: this.workerPath,
            webAssemblyPath: this.webAssemblyPath,
            frameRate: this.frameRate,
            // used by WebAssemblyRecorder; values: usually 30; accepts any.
            bitrate: this.bitrate
            // used by WebAssemblyRecorder; values: 0 to 1000+
          }), e.audio || this.videoRecorder.startRecording();
        }
        if (e.audio && e.video) {
          var f = this, r = _() === !0;
          (e.audio instanceof se && e.video || e.audio !== !0 && e.video !== !0 && e.audio !== e.video) && (r = !1), r === !0 ? (f.audioRecorder = null, f.videoRecorder.startRecording()) : f.videoRecorder.initRecorder(function() {
            f.audioRecorder.initRecorder(function() {
              f.videoRecorder.startRecording(), f.audioRecorder.startRecording();
            });
          });
        }
        e.gif && (t = null, typeof e.gif == "function" && (t = e.gif), this.gifRecorder = new R(i, {
          type: "gif",
          frameRate: this.frameRate || 200,
          quality: this.quality || 10,
          disableLogs: this.disableLogs,
          recorderType: t,
          mimeType: a.gif
        }), this.gifRecorder.startRecording());
      }, this.stopRecording = function(e) {
        e = e || function() {
        }, this.audioRecorder && this.audioRecorder.stopRecording(function(t) {
          e(t, "audio");
        }), this.videoRecorder && this.videoRecorder.stopRecording(function(t) {
          e(t, "video");
        }), this.gifRecorder && this.gifRecorder.stopRecording(function(t) {
          e(t, "gif");
        });
      }, this.pauseRecording = function() {
        this.audioRecorder && this.audioRecorder.pauseRecording(), this.videoRecorder && this.videoRecorder.pauseRecording(), this.gifRecorder && this.gifRecorder.pauseRecording();
      }, this.resumeRecording = function() {
        this.audioRecorder && this.audioRecorder.resumeRecording(), this.videoRecorder && this.videoRecorder.resumeRecording(), this.gifRecorder && this.gifRecorder.resumeRecording();
      }, this.getBlob = function(e) {
        var t = {};
        return this.audioRecorder && (t.audio = this.audioRecorder.getBlob()), this.videoRecorder && (t.video = this.videoRecorder.getBlob()), this.gifRecorder && (t.gif = this.gifRecorder.getBlob()), e && e(t), t;
      }, this.destroy = function() {
        this.audioRecorder && (this.audioRecorder.destroy(), this.audioRecorder = null), this.videoRecorder && (this.videoRecorder.destroy(), this.videoRecorder = null), this.gifRecorder && (this.gifRecorder.destroy(), this.gifRecorder = null);
      }, this.getDataURL = function(e) {
        this.getBlob(function(s) {
          s.audio && s.video ? t(s.audio, function(d) {
            t(s.video, function(f) {
              e({
                audio: d,
                video: f
              });
            });
          }) : s.audio ? t(s.audio, function(d) {
            e({
              audio: d
            });
          }) : s.video && t(s.video, function(d) {
            e({
              video: d
            });
          });
        });
        function t(s, d) {
          if (typeof Worker < "u") {
            var f = a(function(b) {
              postMessage(new FileReaderSync().readAsDataURL(b));
            });
            f.onmessage = function(h) {
              d(h.data);
            }, f.postMessage(s);
          } else {
            var r = new FileReader();
            r.readAsDataURL(s), r.onload = function(h) {
              d(h.target.result);
            };
          }
        }
        function a(s) {
          var d = B.createObjectURL(new Blob([
            s.toString(),
            "this.onmessage =  function (eee) {" + s.name + "(eee.data);}"
          ], {
            type: "application/javascript"
          })), f = new Worker(d), r;
          if (typeof B < "u")
            r = B;
          else if (typeof webkitURL < "u")
            r = webkitURL;
          else
            throw "Neither URL nor webkitURL detected.";
          return r.revokeObjectURL(d), f;
        }
      }, this.writeToDisk = function() {
        R.writeToDisk({
          audio: this.audioRecorder,
          video: this.videoRecorder,
          gif: this.gifRecorder
        });
      }, this.save = function(e) {
        e = e || {
          audio: !0,
          video: !0,
          gif: !0
        }, e.audio && this.audioRecorder && this.audioRecorder.save(typeof e.audio == "string" ? e.audio : ""), e.video && this.videoRecorder && this.videoRecorder.save(typeof e.video == "string" ? e.video : ""), e.gif && this.gifRecorder && this.gifRecorder.save(typeof e.gif == "string" ? e.gif : "");
      };
    }
    me.getFromDisk = R.getFromDisk, me.writeToDisk = R.writeToDisk, typeof R < "u" && (R.MRecordRTC = me);
    var Pe = "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45";
    (function(i) {
      i && (typeof window < "u" || typeof x > "u" || (x.navigator = {
        userAgent: Pe,
        getUserMedia: function() {
        }
      }, x.console || (x.console = {}), (typeof x.console.log > "u" || typeof x.console.error > "u") && (x.console.error = x.console.log = x.console.log || function() {
        console.log(arguments);
      }), typeof document > "u" && (i.document = {
        documentElement: {
          appendChild: function() {
            return "";
          }
        }
      }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
        var e = {
          getContext: function() {
            return e;
          },
          play: function() {
          },
          pause: function() {
          },
          drawImage: function() {
          },
          toDataURL: function() {
            return "";
          },
          style: {}
        };
        return e;
      }, i.HTMLVideoElement = function() {
      }), typeof location > "u" && (i.location = {
        protocol: "file:",
        href: "",
        hash: ""
      }), typeof screen > "u" && (i.screen = {
        width: 0,
        height: 0
      }), typeof B > "u" && (i.URL = {
        createObjectURL: function() {
          return "";
        },
        revokeObjectURL: function() {
          return "";
        }
      }), i.window = x));
    })(typeof x < "u" ? x : null);
    var Q = window.requestAnimationFrame;
    if (typeof Q > "u") {
      if (typeof webkitRequestAnimationFrame < "u")
        Q = webkitRequestAnimationFrame;
      else if (typeof mozRequestAnimationFrame < "u")
        Q = mozRequestAnimationFrame;
      else if (typeof msRequestAnimationFrame < "u")
        Q = msRequestAnimationFrame;
      else if (typeof Q > "u") {
        var Le = 0;
        Q = function(i, e) {
          var t = (/* @__PURE__ */ new Date()).getTime(), a = Math.max(0, 16 - (t - Le)), s = setTimeout(function() {
            i(t + a);
          }, a);
          return Le = t + a, s;
        };
      }
    }
    var Z = window.cancelAnimationFrame;
    typeof Z > "u" && (typeof webkitCancelAnimationFrame < "u" ? Z = webkitCancelAnimationFrame : typeof mozCancelAnimationFrame < "u" ? Z = mozCancelAnimationFrame : typeof msCancelAnimationFrame < "u" ? Z = msCancelAnimationFrame : typeof Z > "u" && (Z = function(i) {
      clearTimeout(i);
    }));
    var ie = window.AudioContext;
    typeof ie > "u" && (typeof webkitAudioContext < "u" && (ie = webkitAudioContext), typeof mozAudioContext < "u" && (ie = mozAudioContext));
    var B = window.URL;
    typeof B > "u" && typeof webkitURL < "u" && (B = webkitURL), typeof navigator < "u" && typeof navigator.getUserMedia > "u" && (typeof navigator.webkitGetUserMedia < "u" && (navigator.getUserMedia = navigator.webkitGetUserMedia), typeof navigator.mozGetUserMedia < "u" && (navigator.getUserMedia = navigator.mozGetUserMedia));
    var ve = navigator.userAgent.indexOf("Edge") !== -1 && (!!navigator.msSaveBlob || !!navigator.msSaveOrOpenBlob), ae = !!window.opera || navigator.userAgent.indexOf("OPR/") !== -1, xe = navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && "netscape" in window && / rv:/.test(navigator.userAgent), X = !ae && !ve && !!navigator.webkitGetUserMedia || Me() || navigator.userAgent.toLowerCase().indexOf("chrome/") !== -1, de = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    de && !X && navigator.userAgent.indexOf("CriOS") !== -1 && (de = !1, X = !0);
    var V = window.MediaStream;
    typeof V > "u" && typeof webkitMediaStream < "u" && (V = webkitMediaStream), typeof V < "u" && typeof V.prototype.stop > "u" && (V.prototype.stop = function() {
      this.getTracks().forEach(function(i) {
        i.stop();
      });
    });
    function ge(i) {
      var e = 1e3, t = ["Bytes", "KB", "MB", "GB", "TB"];
      if (i === 0)
        return "0 Bytes";
      var a = parseInt(Math.floor(Math.log(i) / Math.log(e)), 10);
      return (i / Math.pow(e, a)).toPrecision(3) + " " + t[a];
    }
    function Ae(i, e) {
      if (!i)
        throw "Blob object is required.";
      if (!i.type)
        try {
          i.type = "video/webm";
        } catch {
        }
      var t = (i.type || "video/webm").split("/")[1];
      if (t.indexOf(";") !== -1 && (t = t.split(";")[0]), e && e.indexOf(".") !== -1) {
        var a = e.split(".");
        e = a[0], t = a[1];
      }
      var s = (e || Math.round(Math.random() * 9999999999) + 888888888) + "." + t;
      if (typeof navigator.msSaveOrOpenBlob < "u")
        return navigator.msSaveOrOpenBlob(i, s);
      if (typeof navigator.msSaveBlob < "u")
        return navigator.msSaveBlob(i, s);
      var d = document.createElement("a");
      d.href = B.createObjectURL(i), d.download = s, d.style = "display:none;opacity:0;color:transparent;", (document.body || document.documentElement).appendChild(d), typeof d.click == "function" ? d.click() : (d.target = "_blank", d.dispatchEvent(new MouseEvent("click", {
        view: window,
        bubbles: !0,
        cancelable: !0
      }))), B.revokeObjectURL(d.href);
    }
    function Me() {
      return !!(typeof window < "u" && typeof window.process == "object" && window.process.type === "renderer" || typeof process < "u" && typeof process.versions == "object" && process.versions.electron || typeof navigator == "object" && typeof navigator.userAgent == "string" && navigator.userAgent.indexOf("Electron") >= 0);
    }
    function A(i, e) {
      return !i || !i.getTracks ? [] : i.getTracks().filter(function(t) {
        return t.kind === (e || "audio");
      });
    }
    function De(i, e) {
      "srcObject" in e ? e.srcObject = i : "mozSrcObject" in e ? e.mozSrcObject = i : e.srcObject = i;
    }
    function je(i, e) {
      if (typeof EBML > "u")
        throw new Error("Please link: https://www.webrtc-experiment.com/EBML.js");
      var t = new EBML.Reader(), a = new EBML.Decoder(), s = EBML.tools, d = new FileReader();
      d.onload = function(f) {
        var r = a.decode(this.result);
        r.forEach(function(g) {
          t.read(g);
        }), t.stop();
        var h = s.makeMetadataSeekable(t.metadatas, t.duration, t.cues), b = this.result.slice(t.metadataSize), c = new Blob([h, b], {
          type: "video/webm"
        });
        e(c);
      }, d.readAsArrayBuffer(i);
    }
    typeof R < "u" && (R.invokeSaveAsDialog = Ae, R.getTracks = A, R.getSeekableBlob = je, R.bytesToSize = ge, R.isElectron = Me);
    /**
     * Storage is a standalone object used by {@link RecordRTC} to store reusable objects e.g. "new AudioContext".
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @example
     * Storage.AudioContext === webkitAudioContext
     * @property {webkitAudioContext} AudioContext - Keeps a reference to AudioContext object.
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */
    var te = {};
    typeof ie < "u" ? te.AudioContext = ie : typeof webkitAudioContext < "u" && (te.AudioContext = webkitAudioContext), typeof R < "u" && (R.Storage = te);
    function _() {
      if (xe || de || ve)
        return !0;
      var i = navigator.userAgent, e = "" + parseFloat(navigator.appVersion), t = parseInt(navigator.appVersion, 10), a, s;
      return (X || ae) && (a = i.indexOf("Chrome"), e = i.substring(a + 7)), (s = e.indexOf(";")) !== -1 && (e = e.substring(0, s)), (s = e.indexOf(" ")) !== -1 && (e = e.substring(0, s)), t = parseInt("" + e, 10), isNaN(t) && (e = "" + parseFloat(navigator.appVersion), t = parseInt(navigator.appVersion, 10)), t >= 49;
    }
    /**
     * MediaStreamRecorder is an abstraction layer for {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}. It is used by {@link RecordRTC} to record MediaStream(s) in both Chrome and Firefox.
     * @summary Runs top over {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://github.com/muaz-khan|Muaz Khan}
     * @typedef MediaStreamRecorder
     * @class
     * @example
     * var config = {
     *     mimeType: 'video/webm', // vp8, vp9, h264, mkv, opus/vorbis
     *     audioBitsPerSecond : 256 * 8 * 1024,
     *     videoBitsPerSecond : 256 * 8 * 1024,
     *     bitsPerSecond: 256 * 8 * 1024,  // if this is provided, skip above two
     *     checkForInactiveTracks: true,
     *     timeSlice: 1000, // concatenate intervals based blobs
     *     ondataavailable: function() {} // get intervals based blobs
     * }
     * var recorder = new MediaStreamRecorder(mediaStream, config);
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     *
     *     // or
     *     var blob = recorder.blob;
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {disableLogs:true, initCallback: function, mimeType: "video/webm", timeSlice: 1000}
     * @throws Will throw an error if first argument "MediaStream" is missing. Also throws error if "MediaRecorder API" are not supported by the browser.
     */
    function P(i, e) {
      var c = this;
      if (typeof i > "u")
        throw 'First argument "MediaStream" is required.';
      if (typeof MediaRecorder > "u")
        throw "Your browser does not support the Media Recorder API. Please try other modules e.g. WhammyRecorder or StereoAudioRecorder.";
      if (e = e || {
        // bitsPerSecond: 256 * 8 * 1024,
        mimeType: "video/webm"
      }, e.type === "audio") {
        if (A(i, "video").length && A(i, "audio").length) {
          var t;
          navigator.mozGetUserMedia ? (t = new V(), t.addTrack(A(i, "audio")[0])) : t = new V(A(i, "audio")), i = t;
        }
        (!e.mimeType || e.mimeType.toString().toLowerCase().indexOf("audio") === -1) && (e.mimeType = X ? "audio/webm" : "audio/ogg"), e.mimeType && e.mimeType.toString().toLowerCase() !== "audio/ogg" && navigator.mozGetUserMedia && (e.mimeType = "audio/ogg");
      }
      var a = [];
      this.getArrayOfBlobs = function() {
        return a;
      }, this.record = function() {
        c.blob = null, c.clearRecordedData(), c.timestamps = [], b = [], a = [];
        var g = e;
        e.disableLogs || console.log("Passing following config over MediaRecorder API.", g), r && (r = null), X && !_() && (g = "video/vp8"), typeof MediaRecorder.isTypeSupported == "function" && g.mimeType && (MediaRecorder.isTypeSupported(g.mimeType) || (e.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", g.mimeType), g.mimeType = e.type === "audio" ? "audio/webm" : "video/webm"));
        try {
          r = new MediaRecorder(i, g), e.mimeType = g.mimeType;
        } catch {
          r = new MediaRecorder(i);
        }
        g.mimeType && !MediaRecorder.isTypeSupported && "canRecordMimeType" in r && r.canRecordMimeType(g.mimeType) === !1 && (e.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", g.mimeType)), r.ondataavailable = function(p) {
          if (p.data && b.push("ondataavailable: " + ge(p.data.size)), typeof e.timeSlice == "number") {
            if (p.data && p.data.size && (a.push(p.data), s(), typeof e.ondataavailable == "function")) {
              var m = e.getNativeBlob ? p.data : new Blob([p.data], {
                type: d(g)
              });
              e.ondataavailable(m);
            }
            return;
          }
          if (!p.data || !p.data.size || p.data.size < 100 || c.blob) {
            c.recordingCallback && (c.recordingCallback(new Blob([], {
              type: d(g)
            })), c.recordingCallback = null);
            return;
          }
          c.blob = e.getNativeBlob ? p.data : new Blob([p.data], {
            type: d(g)
          }), c.recordingCallback && (c.recordingCallback(c.blob), c.recordingCallback = null);
        }, r.onstart = function() {
          b.push("started");
        }, r.onpause = function() {
          b.push("paused");
        }, r.onresume = function() {
          b.push("resumed");
        }, r.onstop = function() {
          b.push("stopped");
        }, r.onerror = function(p) {
          p && (p.name || (p.name = "UnknownError"), b.push("error: " + p), e.disableLogs || (p.name.toString().toLowerCase().indexOf("invalidstate") !== -1 ? console.error("The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.", p) : p.name.toString().toLowerCase().indexOf("notsupported") !== -1 ? console.error("MIME type (", g.mimeType, ") is not supported.", p) : p.name.toString().toLowerCase().indexOf("security") !== -1 ? console.error("MediaRecorder security error", p) : p.name === "OutOfMemory" ? console.error("The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.", p) : p.name === "IllegalStreamModification" ? console.error("A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.", p) : p.name === "OtherRecordingError" ? console.error("Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.", p) : p.name === "GenericError" ? console.error("The UA cannot provide the codec or recording option that has been requested.", p) : console.error("MediaRecorder Error", p)), function(m) {
            if (!c.manuallyStopped && r && r.state === "inactive") {
              delete e.timeslice, r.start(10 * 60 * 1e3);
              return;
            }
            setTimeout(m, 1e3);
          }(), r.state !== "inactive" && r.state !== "stopped" && r.stop());
        }, typeof e.timeSlice == "number" ? (s(), r.start(e.timeSlice)) : r.start(36e5), e.initCallback && e.initCallback();
      }, this.timestamps = [];
      function s() {
        c.timestamps.push((/* @__PURE__ */ new Date()).getTime()), typeof e.onTimeStamp == "function" && e.onTimeStamp(c.timestamps[c.timestamps.length - 1], c.timestamps);
      }
      function d(g) {
        return r && r.mimeType ? r.mimeType : g.mimeType || "video/webm";
      }
      this.stop = function(g) {
        g = g || function() {
        }, c.manuallyStopped = !0, r && (this.recordingCallback = g, r.state === "recording" && r.stop(), typeof e.timeSlice == "number" && setTimeout(function() {
          c.blob = new Blob(a, {
            type: d(e)
          }), c.recordingCallback(c.blob);
        }, 100));
      }, this.pause = function() {
        r && r.state === "recording" && r.pause();
      }, this.resume = function() {
        r && r.state === "paused" && r.resume();
      }, this.clearRecordedData = function() {
        r && r.state === "recording" && c.stop(f), f();
      };
      function f() {
        a = [], r = null, c.timestamps = [];
      }
      var r;
      this.getInternalRecorder = function() {
        return r;
      };
      function h() {
        if ("active" in i) {
          if (!i.active)
            return !1;
        } else if ("ended" in i && i.ended)
          return !1;
        return !0;
      }
      this.blob = null, this.getState = function() {
        return r && r.state || "inactive";
      };
      var b = [];
      this.getAllStates = function() {
        return b;
      }, typeof e.checkForInactiveTracks > "u" && (e.checkForInactiveTracks = !1);
      var c = this;
      (function g() {
        if (!(!r || e.checkForInactiveTracks === !1)) {
          if (h() === !1) {
            e.disableLogs || console.log("MediaStream seems stopped."), c.stop();
            return;
          }
          setTimeout(g, 1e3);
        }
      })(), this.name = "MediaStreamRecorder", this.toString = function() {
        return this.name;
      };
    }
    typeof R < "u" && (R.MediaStreamRecorder = P);
    /**
     * StereoAudioRecorder is a standalone class used by {@link RecordRTC} to bring "stereo" audio-recording in chrome.
     * @summary JavaScript standalone object for stereo audio recording.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef StereoAudioRecorder
     * @class
     * @example
     * var recorder = new StereoAudioRecorder(MediaStream, {
     *     sampleRate: 44100,
     *     bufferSize: 4096
     * });
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {sampleRate: 44100, bufferSize: 4096, numberOfAudioChannels: 1, etc.}
     */
    function se(i, e) {
      if (!A(i, "audio").length)
        throw "Your stream has no audio tracks.";
      e = e || {};
      var t = this, a = [], s = [], d = !1, f = 0, r, h = 2, b = e.desiredSampRate;
      e.leftChannel === !0 && (h = 1), e.numberOfAudioChannels === 1 && (h = 1), (!h || h < 1) && (h = 2), e.disableLogs || console.log("StereoAudioRecorder is set to record number of channels: " + h), typeof e.checkForInactiveTracks > "u" && (e.checkForInactiveTracks = !0);
      function c() {
        if (e.checkForInactiveTracks === !1)
          return !0;
        if ("active" in i) {
          if (!i.active)
            return !1;
        } else if ("ended" in i && i.ended)
          return !1;
        return !0;
      }
      this.record = function() {
        if (c() === !1)
          throw "Please make sure MediaStream is active.";
        C(), u = v = !1, d = !0, typeof e.timeSlice < "u" && L();
      };
      function g(S, U) {
        function F(M, ne) {
          var N = M.numberOfAudioChannels, E = M.leftBuffers.slice(0), J = M.rightBuffers.slice(0), j = M.sampleRate, Y = M.internalInterleavedLength, G = M.desiredSampRate;
          N === 2 && (E = we(E, Y), J = we(J, Y), G && (E = oe(E, G, j), J = oe(J, G, j))), N === 1 && (E = we(E, Y), G && (E = oe(E, G, j))), G && (j = G);
          function oe(D, H, z) {
            var W = Math.round(D.length * (H / z)), O = [], $ = Number((D.length - 1) / (W - 1));
            O[0] = D[0];
            for (var ee = 1; ee < W - 1; ee++) {
              var Ce = ee * $, Ie = Number(Math.floor(Ce)).toFixed(), He = Number(Math.ceil(Ce)).toFixed(), Ke = Ce - Ie;
              O[ee] = We(D[Ie], D[He], Ke);
            }
            return O[W - 1] = D[D.length - 1], O;
          }
          function We(D, H, z) {
            return D + (H - D) * z;
          }
          function we(D, H) {
            for (var z = new Float64Array(H), W = 0, O = D.length, $ = 0; $ < O; $++) {
              var ee = D[$];
              z.set(ee, W), W += ee.length;
            }
            return z;
          }
          function Ne(D, H) {
            for (var z = D.length + H.length, W = new Float64Array(z), O = 0, $ = 0; $ < z; )
              W[$++] = D[O], W[$++] = H[O], O++;
            return W;
          }
          function le(D, H, z) {
            for (var W = z.length, O = 0; O < W; O++)
              D.setUint8(H + O, z.charCodeAt(O));
          }
          var he;
          N === 2 && (he = Ne(E, J)), N === 1 && (he = E);
          var pe = he.length, Ge = 44 + pe * 2, ye = new ArrayBuffer(Ge), I = new DataView(ye);
          le(I, 0, "RIFF"), I.setUint32(4, 36 + pe * 2, !0), le(I, 8, "WAVE"), le(I, 12, "fmt "), I.setUint32(16, 16, !0), I.setUint16(20, 1, !0), I.setUint16(22, N, !0), I.setUint32(24, j, !0), I.setUint32(28, j * N * 2, !0), I.setUint16(32, N * 2, !0), I.setUint16(34, 16, !0), le(I, 36, "data"), I.setUint32(40, pe * 2, !0);
          for (var Ve = pe, Fe = 44, qe = 1, Re = 0; Re < Ve; Re++)
            I.setInt16(Fe, he[Re] * (32767 * qe), !0), Fe += 2;
          if (ne)
            return ne({
              buffer: ye,
              view: I
            });
          postMessage({
            buffer: ye,
            view: I
          });
        }
        if (S.noWorker) {
          F(S, function(M) {
            U(M.buffer, M.view);
          });
          return;
        }
        var K = p(F);
        K.onmessage = function(M) {
          U(M.data.buffer, M.data.view), B.revokeObjectURL(K.workerURL), K.terminate();
        }, K.postMessage(S);
      }
      function p(S) {
        var U = B.createObjectURL(new Blob([
          S.toString(),
          ";this.onmessage =  function (eee) {" + S.name + "(eee.data);}"
        ], {
          type: "application/javascript"
        })), F = new Worker(U);
        return F.workerURL = U, F;
      }
      this.stop = function(S) {
        S = S || function() {
        }, d = !1, g({
          desiredSampRate: b,
          sampleRate: o,
          numberOfAudioChannels: h,
          internalInterleavedLength: f,
          leftBuffers: a,
          rightBuffers: h === 1 ? [] : s,
          noWorker: e.noWorker
        }, function(U, F) {
          t.blob = new Blob([F], {
            type: "audio/wav"
          }), t.buffer = new ArrayBuffer(F.buffer.byteLength), t.view = F, t.sampleRate = b || o, t.bufferSize = k, t.length = f, u = !1, S && S(t.blob);
        });
      }, typeof R.Storage > "u" && (R.Storage = {
        AudioContextConstructor: null,
        AudioContext: window.AudioContext || window.webkitAudioContext
      }), (!R.Storage.AudioContextConstructor || R.Storage.AudioContextConstructor.state === "closed") && (R.Storage.AudioContextConstructor = new R.Storage.AudioContext());
      var m = R.Storage.AudioContextConstructor, l = m.createMediaStreamSource(i), T = [0, 256, 512, 1024, 2048, 4096, 8192, 16384], k = typeof e.bufferSize > "u" ? 4096 : e.bufferSize;
      if (T.indexOf(k) === -1 && (e.disableLogs || console.log("Legal values for buffer-size are " + JSON.stringify(T, null, "	"))), m.createJavaScriptNode)
        r = m.createJavaScriptNode(k, h, h);
      else if (m.createScriptProcessor)
        r = m.createScriptProcessor(k, h, h);
      else
        throw "WebAudio API has no support on this browser.";
      l.connect(r), e.bufferSize || (k = r.bufferSize);
      var o = typeof e.sampleRate < "u" ? e.sampleRate : m.sampleRate || 44100;
      (o < 22050 || o > 96e3) && (e.disableLogs || console.log("sample-rate must be under range 22050 and 96000.")), e.disableLogs || e.desiredSampRate && console.log("Desired sample-rate: " + e.desiredSampRate);
      var v = !1;
      this.pause = function() {
        v = !0;
      }, this.resume = function() {
        if (c() === !1)
          throw "Please make sure MediaStream is active.";
        if (!d) {
          e.disableLogs || console.log("Seems recording has been restarted."), this.record();
          return;
        }
        v = !1;
      }, this.clearRecordedData = function() {
        e.checkForInactiveTracks = !1, d && this.stop(n), n();
      };
      function C() {
        a = [], s = [], f = 0, u = !1, d = !1, v = !1, m = null, t.leftchannel = a, t.rightchannel = s, t.numberOfAudioChannels = h, t.desiredSampRate = b, t.sampleRate = o, t.recordingLength = f, y = {
          left: [],
          right: [],
          recordingLength: 0
        };
      }
      function n() {
        r && (r.onaudioprocess = null, r.disconnect(), r = null), l && (l.disconnect(), l = null), C();
      }
      this.name = "StereoAudioRecorder", this.toString = function() {
        return this.name;
      };
      var u = !1;
      function w(S) {
        if (!v) {
          if (c() === !1 && (e.disableLogs || console.log("MediaStream seems stopped."), r.disconnect(), d = !1), !d) {
            l && (l.disconnect(), l = null);
            return;
          }
          u || (u = !0, e.onAudioProcessStarted && e.onAudioProcessStarted(), e.initCallback && e.initCallback());
          var U = S.inputBuffer.getChannelData(0), F = new Float32Array(U);
          if (a.push(F), h === 2) {
            var K = S.inputBuffer.getChannelData(1), M = new Float32Array(K);
            s.push(M);
          }
          f += k, t.recordingLength = f, typeof e.timeSlice < "u" && (y.recordingLength += k, y.left.push(F), h === 2 && y.right.push(M));
        }
      }
      r.onaudioprocess = w, m.createMediaStreamDestination ? r.connect(m.createMediaStreamDestination()) : r.connect(m.destination), this.leftchannel = a, this.rightchannel = s, this.numberOfAudioChannels = h, this.desiredSampRate = b, this.sampleRate = o, t.recordingLength = f;
      var y = {
        left: [],
        right: [],
        recordingLength: 0
      };
      function L() {
        !d || typeof e.ondataavailable != "function" || typeof e.timeSlice > "u" || (y.left.length ? (g({
          desiredSampRate: b,
          sampleRate: o,
          numberOfAudioChannels: h,
          internalInterleavedLength: y.recordingLength,
          leftBuffers: y.left,
          rightBuffers: h === 1 ? [] : y.right
        }, function(S, U) {
          var F = new Blob([U], {
            type: "audio/wav"
          });
          e.ondataavailable(F), setTimeout(L, e.timeSlice);
        }), y = {
          left: [],
          right: [],
          recordingLength: 0
        }) : setTimeout(L, e.timeSlice));
      }
    }
    typeof R < "u" && (R.StereoAudioRecorder = se);
    /**
     * CanvasRecorder is a standalone class used by {@link RecordRTC} to bring HTML5-Canvas recording into video WebM. It uses HTML2Canvas library and runs top over {@link Whammy}.
     * @summary HTML2Canvas recording into video WebM.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef CanvasRecorder
     * @class
     * @example
     * var recorder = new CanvasRecorder(htmlElement, { disableLogs: true, useWhammyRecorder: true });
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {HTMLElement} htmlElement - querySelector/getElementById/getElementsByTagName[0]/etc.
     * @param {object} config - {disableLogs:true, initCallback: function}
     */
    function ue(i, e) {
      if (typeof html2canvas > "u")
        throw "Please link: https://www.webrtc-experiment.com/screenshot.js";
      e = e || {}, e.frameInterval || (e.frameInterval = 10);
      var t = !1;
      ["captureStream", "mozCaptureStream", "webkitCaptureStream"].forEach(function(T) {
        T in document.createElement("canvas") && (t = !0);
      });
      var a = (!!window.webkitRTCPeerConnection || !!window.webkitGetUserMedia) && !!window.chrome, s = 50, d = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
      a && d && d[2] && (s = parseInt(d[2], 10)), a && s < 52 && (t = !1), e.useWhammyRecorder && (t = !1);
      var f, r;
      if (t)
        if (e.disableLogs || console.log("Your browser supports both MediRecorder API and canvas.captureStream!"), i instanceof HTMLCanvasElement)
          f = i;
        else if (i instanceof CanvasRenderingContext2D)
          f = i.canvas;
        else
          throw "Please pass either HTMLCanvasElement or CanvasRenderingContext2D.";
      else navigator.mozGetUserMedia && (e.disableLogs || console.error("Canvas recording is NOT supported in Firefox."));
      var h;
      this.record = function() {
        if (h = !0, t && !e.useWhammyRecorder) {
          var T;
          "captureStream" in f ? T = f.captureStream(25) : "mozCaptureStream" in f ? T = f.mozCaptureStream(25) : "webkitCaptureStream" in f && (T = f.webkitCaptureStream(25));
          try {
            var k = new V();
            k.addTrack(A(T, "video")[0]), T = k;
          } catch {
          }
          if (!T)
            throw "captureStream API are NOT available.";
          r = new P(T, {
            mimeType: e.mimeType || "video/webm"
          }), r.record();
        } else
          l.frames = [], m = (/* @__PURE__ */ new Date()).getTime(), p();
        e.initCallback && e.initCallback();
      }, this.getWebPImages = function(T) {
        if (i.nodeName.toLowerCase() !== "canvas") {
          T();
          return;
        }
        var k = l.frames.length;
        l.frames.forEach(function(o, v) {
          var C = k - v;
          e.disableLogs || console.log(C + "/" + k + " frames remaining"), e.onEncodingCallback && e.onEncodingCallback(C, k);
          var n = o.image.toDataURL("image/webp", 1);
          l.frames[v].image = n;
        }), e.disableLogs || console.log("Generating WebM"), T();
      }, this.stop = function(T) {
        h = !1;
        var k = this;
        if (t && r) {
          r.stop(T);
          return;
        }
        this.getWebPImages(function() {
          l.compile(function(o) {
            e.disableLogs || console.log("Recording finished!"), k.blob = o, k.blob.forEach && (k.blob = new Blob([], {
              type: "video/webm"
            })), T && T(k.blob), l.frames = [];
          });
        });
      };
      var b = !1;
      this.pause = function() {
        if (b = !0, r instanceof P) {
          r.pause();
          return;
        }
      }, this.resume = function() {
        if (b = !1, r instanceof P) {
          r.resume();
          return;
        }
        h || this.record();
      }, this.clearRecordedData = function() {
        h && this.stop(c), c();
      };
      function c() {
        l.frames = [], h = !1, b = !1;
      }
      this.name = "CanvasRecorder", this.toString = function() {
        return this.name;
      };
      function g() {
        var T = document.createElement("canvas"), k = T.getContext("2d");
        return T.width = i.width, T.height = i.height, k.drawImage(i, 0, 0), T;
      }
      function p() {
        if (b)
          return m = (/* @__PURE__ */ new Date()).getTime(), setTimeout(p, 500);
        if (i.nodeName.toLowerCase() === "canvas") {
          var T = (/* @__PURE__ */ new Date()).getTime() - m;
          m = (/* @__PURE__ */ new Date()).getTime(), l.frames.push({
            image: g(),
            duration: T
          }), h && setTimeout(p, e.frameInterval);
          return;
        }
        html2canvas(i, {
          grabMouse: typeof e.showMousePointer > "u" || e.showMousePointer,
          onrendered: function(k) {
            var o = (/* @__PURE__ */ new Date()).getTime() - m;
            if (!o)
              return setTimeout(p, e.frameInterval);
            m = (/* @__PURE__ */ new Date()).getTime(), l.frames.push({
              image: k.toDataURL("image/webp", 1),
              duration: o
            }), h && setTimeout(p, e.frameInterval);
          }
        });
      }
      var m = (/* @__PURE__ */ new Date()).getTime(), l = new be.Video(100);
    }
    typeof R < "u" && (R.CanvasRecorder = ue);
    /**
     * WhammyRecorder is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It runs top over {@link Whammy}.
     * @summary Video recording feature in Chrome.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef WhammyRecorder
     * @class
     * @example
     * var recorder = new WhammyRecorder(mediaStream);
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {disableLogs: true, initCallback: function, video: HTMLVideoElement, etc.}
     */
    function fe(i, e) {
      e = e || {}, e.frameInterval || (e.frameInterval = 10), e.disableLogs || console.log("Using frames-interval:", e.frameInterval), this.record = function() {
        e.width || (e.width = 320), e.height || (e.height = 240), e.video || (e.video = {
          width: e.width,
          height: e.height
        }), e.canvas || (e.canvas = {
          width: e.width,
          height: e.height
        }), h.width = e.canvas.width || 320, h.height = e.canvas.height || 240, b = h.getContext("2d"), e.video && e.video instanceof HTMLVideoElement ? (c = e.video.cloneNode(), e.initCallback && e.initCallback()) : (c = document.createElement("video"), De(i, c), c.onloadedmetadata = function() {
          e.initCallback && e.initCallback();
        }, c.width = e.video.width, c.height = e.video.height), c.muted = !0, c.play(), g = (/* @__PURE__ */ new Date()).getTime(), p = new be.Video(), e.disableLogs || (console.log("canvas resolutions", h.width, "*", h.height), console.log("video width/height", c.width || h.width, "*", c.height || h.height)), t(e.frameInterval);
      };
      function t(m) {
        m = typeof m < "u" ? m : 10;
        var l = (/* @__PURE__ */ new Date()).getTime() - g;
        if (!l)
          return setTimeout(t, m, m);
        if (f)
          return g = (/* @__PURE__ */ new Date()).getTime(), setTimeout(t, 100);
        g = (/* @__PURE__ */ new Date()).getTime(), c.paused && c.play(), b.drawImage(c, 0, 0, h.width, h.height), p.frames.push({
          duration: l,
          image: h.toDataURL("image/webp")
        }), d || setTimeout(t, m, m);
      }
      function a(m) {
        var l = -1, T = m.length;
        (function k() {
          if (l++, l === T) {
            m.callback();
            return;
          }
          setTimeout(function() {
            m.functionToLoop(k, l);
          }, 1);
        })();
      }
      function s(m, l, T, k, o) {
        var v = document.createElement("canvas");
        v.width = h.width, v.height = h.height;
        var C = v.getContext("2d"), n = [], u = m.length, w = {
          r: 0,
          g: 0,
          b: 0
        }, y = Math.sqrt(
          Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2)
        ), L = 0, S = 0, U = !1;
        a({
          length: u,
          functionToLoop: function(F, K) {
            var M, ne, N, E = function() {
              !U && N - M <= N * S || (U = !0, n.push(m[K])), F();
            };
            if (U)
              E();
            else {
              var J = new Image();
              J.onload = function() {
                C.drawImage(J, 0, 0, h.width, h.height);
                var j = C.getImageData(0, 0, h.width, h.height);
                M = 0, ne = j.data.length, N = j.data.length / 4;
                for (var Y = 0; Y < ne; Y += 4) {
                  var G = {
                    r: j.data[Y],
                    g: j.data[Y + 1],
                    b: j.data[Y + 2]
                  }, oe = Math.sqrt(
                    Math.pow(G.r - w.r, 2) + Math.pow(G.g - w.g, 2) + Math.pow(G.b - w.b, 2)
                  );
                  oe <= y * L && M++;
                }
                E();
              }, J.src = m[K].image;
            }
          },
          callback: function() {
            n = n.concat(m.slice(u)), n.length <= 0 && n.push(m[m.length - 1]), o(n);
          }
        });
      }
      var d = !1;
      this.stop = function(m) {
        m = m || function() {
        }, d = !0;
        var l = this;
        setTimeout(function() {
          s(p.frames, -1, null, null, function(T) {
            p.frames = T, e.advertisement && e.advertisement.length && (p.frames = e.advertisement.concat(p.frames)), p.compile(function(k) {
              l.blob = k, l.blob.forEach && (l.blob = new Blob([], {
                type: "video/webm"
              })), m && m(l.blob);
            });
          });
        }, 10);
      };
      var f = !1;
      this.pause = function() {
        f = !0;
      }, this.resume = function() {
        f = !1, d && this.record();
      }, this.clearRecordedData = function() {
        d || this.stop(r), r();
      };
      function r() {
        p.frames = [], d = !0, f = !1;
      }
      this.name = "WhammyRecorder", this.toString = function() {
        return this.name;
      };
      var h = document.createElement("canvas"), b = h.getContext("2d"), c, g, p;
    }
    typeof R < "u" && (R.WhammyRecorder = fe);
    /**
     * Whammy is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It is written by {@link https://github.com/antimatter15|antimatter15}
     * @summary A real time javascript webm encoder based on a canvas hack.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef Whammy
     * @class
     * @example
     * var recorder = new Whammy().Video(15);
     * recorder.add(context || canvas || dataURL);
     * var output = recorder.compile();
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */
    var be = function() {
      function i(a) {
        this.frames = [], this.duration = a || 1, this.quality = 0.8;
      }
      i.prototype.add = function(a, s) {
        if ("canvas" in a && (a = a.canvas), "toDataURL" in a && (a = a.toDataURL("image/webp", this.quality)), !/^data:image\/webp;base64,/ig.test(a))
          throw "Input must be formatted properly as a base64 encoded DataURI of type image/webp";
        this.frames.push({
          image: a,
          duration: s || this.duration
        });
      };
      function e(a) {
        var s = B.createObjectURL(new Blob([
          a.toString(),
          "this.onmessage =  function (eee) {" + a.name + "(eee.data);}"
        ], {
          type: "application/javascript"
        })), d = new Worker(s);
        return B.revokeObjectURL(s), d;
      }
      function t(a) {
        function s(o) {
          var v = f(o);
          if (!v)
            return [];
          for (var C = 3e4, n = [{
            id: 440786851,
            // EBML
            data: [{
              data: 1,
              id: 17030
              // EBMLVersion
            }, {
              data: 1,
              id: 17143
              // EBMLReadVersion
            }, {
              data: 4,
              id: 17138
              // EBMLMaxIDLength
            }, {
              data: 8,
              id: 17139
              // EBMLMaxSizeLength
            }, {
              data: "webm",
              id: 17026
              // DocType
            }, {
              data: 2,
              id: 17031
              // DocTypeVersion
            }, {
              data: 2,
              id: 17029
              // DocTypeReadVersion
            }]
          }, {
            id: 408125543,
            // Segment
            data: [{
              id: 357149030,
              // Info
              data: [{
                data: 1e6,
                //do things in millisecs (num of nanosecs for duration scale)
                id: 2807729
                // TimecodeScale
              }, {
                data: "whammy",
                id: 19840
                // MuxingApp
              }, {
                data: "whammy",
                id: 22337
                // WritingApp
              }, {
                data: T(v.duration),
                id: 17545
                // Duration
              }]
            }, {
              id: 374648427,
              // Tracks
              data: [{
                id: 174,
                // TrackEntry
                data: [{
                  data: 1,
                  id: 215
                  // TrackNumber
                }, {
                  data: 1,
                  id: 29637
                  // TrackUID
                }, {
                  data: 0,
                  id: 156
                  // FlagLacing
                }, {
                  data: "und",
                  id: 2274716
                  // Language
                }, {
                  data: "V_VP8",
                  id: 134
                  // CodecID
                }, {
                  data: "VP8",
                  id: 2459272
                  // CodecName
                }, {
                  data: 1,
                  id: 131
                  // TrackType
                }, {
                  id: 224,
                  // Video
                  data: [{
                    data: v.width,
                    id: 176
                    // PixelWidth
                  }, {
                    data: v.height,
                    id: 186
                    // PixelHeight
                  }]
                }]
              }]
            }]
          }], u = 0, w = 0; u < o.length; ) {
            var y = [], L = 0;
            do
              y.push(o[u]), L += o[u].duration, u++;
            while (u < o.length && L < C);
            var S = 0, U = {
              id: 524531317,
              // Cluster
              data: d(w, S, y)
            };
            n[1].data.push(U), w += L;
          }
          return c(n);
        }
        function d(o, v, C) {
          return [{
            data: o,
            id: 231
            // Timecode
          }].concat(C.map(function(n) {
            var u = g({
              frame: n.data.slice(4),
              trackNum: 1,
              timecode: Math.round(v)
            });
            return v += n.duration, {
              data: u,
              id: 163
            };
          }));
        }
        function f(o) {
          if (!o[0]) {
            postMessage({
              error: "Something went wrong. Maybe WebP format is not supported in the current browser."
            });
            return;
          }
          for (var v = o[0].width, C = o[0].height, n = o[0].duration, u = 1; u < o.length; u++)
            n += o[u].duration;
          return {
            duration: n,
            width: v,
            height: C
          };
        }
        function r(o) {
          for (var v = []; o > 0; )
            v.push(o & 255), o = o >> 8;
          return new Uint8Array(v.reverse());
        }
        function h(o) {
          return new Uint8Array(o.split("").map(function(v) {
            return v.charCodeAt(0);
          }));
        }
        function b(o) {
          var v = [], C = o.length % 8 ? new Array(9 - o.length % 8).join("0") : "";
          o = C + o;
          for (var n = 0; n < o.length; n += 8)
            v.push(parseInt(o.substr(n, 8), 2));
          return new Uint8Array(v);
        }
        function c(o) {
          for (var v = [], C = 0; C < o.length; C++) {
            var n = o[C].data;
            typeof n == "object" && (n = c(n)), typeof n == "number" && (n = b(n.toString(2))), typeof n == "string" && (n = h(n));
            var u = n.size || n.byteLength || n.length, w = Math.ceil(Math.ceil(Math.log(u) / Math.log(2)) / 8), y = u.toString(2), L = new Array(w * 7 + 7 + 1 - y.length).join("0") + y, S = new Array(w).join("0") + "1" + L;
            v.push(r(o[C].id)), v.push(b(S)), v.push(n);
          }
          return new Blob(v, {
            type: "video/webm"
          });
        }
        function g(o) {
          var v = 0;
          v |= 128;
          var C = [o.trackNum | 128, o.timecode >> 8, o.timecode & 255, v].map(function(n) {
            return String.fromCharCode(n);
          }).join("") + o.frame;
          return C;
        }
        function p(o) {
          for (var v = o.RIFF[0].WEBP[0], C = v.indexOf("*"), n = 0, u = []; n < 4; n++)
            u[n] = v.charCodeAt(C + 3 + n);
          var w, y, L;
          return L = u[1] << 8 | u[0], w = L & 16383, L = u[3] << 8 | u[2], y = L & 16383, {
            width: w,
            height: y,
            data: v,
            riff: o
          };
        }
        function m(o, v) {
          return parseInt(o.substr(v + 4, 4).split("").map(function(C) {
            var n = C.charCodeAt(0).toString(2);
            return new Array(8 - n.length + 1).join("0") + n;
          }).join(""), 2);
        }
        function l(o) {
          for (var v = 0, C = {}; v < o.length; ) {
            var n = o.substr(v, 4), u = m(o, v), w = o.substr(v + 4 + 4, u);
            v += 8 + u, C[n] = C[n] || [], n === "RIFF" || n === "LIST" ? C[n].push(l(w)) : C[n].push(w);
          }
          return C;
        }
        function T(o) {
          return [].slice.call(
            new Uint8Array(new Float64Array([o]).buffer),
            0
          ).map(function(v) {
            return String.fromCharCode(v);
          }).reverse().join("");
        }
        var k = new s(a.map(function(o) {
          var v = p(l(atob(o.image.slice(23))));
          return v.duration = o.duration, v;
        }));
        postMessage(k);
      }
      return i.prototype.compile = function(a) {
        var s = e(t);
        s.onmessage = function(d) {
          if (d.data.error) {
            console.error(d.data.error);
            return;
          }
          a(d.data);
        }, s.postMessage(this.frames);
      }, {
        /**
         * A more abstract-ish API.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * @param {?number} speed - 0.8
         * @param {?number} quality - 100
         */
        Video: i
      };
    }();
    typeof R < "u" && (R.Whammy = be);
    /**
     * DiskStorage is a standalone object used by {@link RecordRTC} to store recorded blobs in IndexedDB storage.
     * @summary Writing blobs into IndexedDB.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @example
     * DiskStorage.Store({
     *     audioBlob: yourAudioBlob,
     *     videoBlob: yourVideoBlob,
     *     gifBlob  : yourGifBlob
     * });
     * DiskStorage.Fetch(function(dataURL, type) {
     *     if(type === 'audioBlob') { }
     *     if(type === 'videoBlob') { }
     *     if(type === 'gifBlob')   { }
     * });
     * // DiskStorage.dataStoreName = 'recordRTC';
     * // DiskStorage.onError = function(error) { };
     * @property {function} init - This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
     * @property {function} Fetch - This method fetches stored blobs from IndexedDB.
     * @property {function} Store - This method stores blobs in IndexedDB.
     * @property {function} onError - This function is invoked for any known/unknown error.
     * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */
    var q = {
      /**
       * This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
       * @method
       * @memberof DiskStorage
       * @internal
       * @example
       * DiskStorage.init();
       */
      init: function() {
        var i = this;
        if (typeof indexedDB > "u" || typeof indexedDB.open > "u") {
          console.error("IndexedDB API are not available in this browser.");
          return;
        }
        var e = 1, t = this.dbName || location.href.replace(/\/|:|#|%|\.|\[|\]/g, ""), a, s = indexedDB.open(t, e);
        function d(r) {
          r.createObjectStore(i.dataStoreName);
        }
        function f() {
          var r = a.transaction([i.dataStoreName], "readwrite");
          i.videoBlob && r.objectStore(i.dataStoreName).put(i.videoBlob, "videoBlob"), i.gifBlob && r.objectStore(i.dataStoreName).put(i.gifBlob, "gifBlob"), i.audioBlob && r.objectStore(i.dataStoreName).put(i.audioBlob, "audioBlob");
          function h(b) {
            r.objectStore(i.dataStoreName).get(b).onsuccess = function(c) {
              i.callback && i.callback(c.target.result, b);
            };
          }
          h("audioBlob"), h("videoBlob"), h("gifBlob");
        }
        s.onerror = i.onError, s.onsuccess = function() {
          if (a = s.result, a.onerror = i.onError, a.setVersion)
            if (a.version !== e) {
              var r = a.setVersion(e);
              r.onsuccess = function() {
                d(a), f();
              };
            } else
              f();
          else
            f();
        }, s.onupgradeneeded = function(r) {
          d(r.target.result);
        };
      },
      /**
       * This method fetches stored blobs from IndexedDB.
       * @method
       * @memberof DiskStorage
       * @internal
       * @example
       * DiskStorage.Fetch(function(dataURL, type) {
       *     if(type === 'audioBlob') { }
       *     if(type === 'videoBlob') { }
       *     if(type === 'gifBlob')   { }
       * });
       */
      Fetch: function(i) {
        return this.callback = i, this.init(), this;
      },
      /**
       * This method stores blobs in IndexedDB.
       * @method
       * @memberof DiskStorage
       * @internal
       * @example
       * DiskStorage.Store({
       *     audioBlob: yourAudioBlob,
       *     videoBlob: yourVideoBlob,
       *     gifBlob  : yourGifBlob
       * });
       */
      Store: function(i) {
        return this.audioBlob = i.audioBlob, this.videoBlob = i.videoBlob, this.gifBlob = i.gifBlob, this.init(), this;
      },
      /**
       * This function is invoked for any known/unknown error.
       * @method
       * @memberof DiskStorage
       * @internal
       * @example
       * DiskStorage.onError = function(error){
       *     alerot( JSON.stringify(error) );
       * };
       */
      onError: function(i) {
        console.error(JSON.stringify(i, null, "	"));
      },
      /**
       * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
       * @memberof DiskStorage
       * @internal
       * @example
       * DiskStorage.dataStoreName = 'recordRTC';
       */
      dataStoreName: "recordRTC",
      dbName: null
    };
    typeof R < "u" && (R.DiskStorage = q);
    /**
     * GifRecorder is standalone calss used by {@link RecordRTC} to record video or canvas into animated gif.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef GifRecorder
     * @class
     * @example
     * var recorder = new GifRecorder(mediaStream || canvas || context, { onGifPreview: function, onGifRecordingStarted: function, width: 1280, height: 720, frameRate: 200, quality: 10 });
     * recorder.record();
     * recorder.stop(function(blob) {
     *     img.src = URL.createObjectURL(blob);
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object or HTMLCanvasElement or CanvasRenderingContext2D.
     * @param {object} config - {disableLogs:true, initCallback: function, width: 320, height: 240, frameRate: 200, quality: 10}
     */
    function ce(i, e) {
      if (typeof GIFEncoder > "u") {
        var t = document.createElement("script");
        t.src = "https://www.webrtc-experiment.com/gif-recorder.js", (document.body || document.documentElement).appendChild(t);
      }
      e = e || {};
      var a = i instanceof CanvasRenderingContext2D || i instanceof HTMLCanvasElement;
      this.record = function() {
        if (typeof GIFEncoder > "u") {
          setTimeout(m.record, 1e3);
          return;
        }
        if (!h) {
          setTimeout(m.record, 1e3);
          return;
        }
        a || (e.width || (e.width = b.offsetWidth || 320), e.height || (e.height = b.offsetHeight || 240), e.video || (e.video = {
          width: e.width,
          height: e.height
        }), e.canvas || (e.canvas = {
          width: e.width,
          height: e.height
        }), f.width = e.canvas.width || 320, f.height = e.canvas.height || 240, b.width = e.video.width || 320, b.height = e.video.height || 240), p = new GIFEncoder(), p.setRepeat(0), p.setDelay(e.frameRate || 200), p.setQuality(e.quality || 10), p.start(), typeof e.onGifRecordingStarted == "function" && e.onGifRecordingStarted();
        function l(T) {
          if (m.clearedRecordedData !== !0) {
            if (s)
              return setTimeout(function() {
                l(T);
              }, 100);
            c = Q(l), typeof g === void 0 && (g = T), !(T - g < 90) && (!a && b.paused && b.play(), a || r.drawImage(b, 0, 0, f.width, f.height), e.onGifPreview && e.onGifPreview(f.toDataURL("image/png")), p.addFrame(r), g = T);
          }
        }
        c = Q(l), e.initCallback && e.initCallback();
      }, this.stop = function(l) {
        l = l || function() {
        }, c && Z(c), this.blob = new Blob([new Uint8Array(p.stream().bin)], {
          type: "image/gif"
        }), l(this.blob), p.stream().bin = [];
      };
      var s = !1;
      this.pause = function() {
        s = !0;
      }, this.resume = function() {
        s = !1;
      }, this.clearRecordedData = function() {
        m.clearedRecordedData = !0, d();
      };
      function d() {
        p && (p.stream().bin = []);
      }
      this.name = "GifRecorder", this.toString = function() {
        return this.name;
      };
      var f = document.createElement("canvas"), r = f.getContext("2d");
      a && (i instanceof CanvasRenderingContext2D ? (r = i, f = r.canvas) : i instanceof HTMLCanvasElement && (r = i.getContext("2d"), f = i));
      var h = !0;
      if (!a) {
        var b = document.createElement("video");
        b.muted = !0, b.autoplay = !0, b.playsInline = !0, h = !1, b.onloadedmetadata = function() {
          h = !0;
        }, De(i, b), b.play();
      }
      var c = null, g, p, m = this;
    }
    typeof R < "u" && (R.GifRecorder = ce);
    function Be(i, e) {
      var t = "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45";
      (function(n) {
        typeof R < "u" || n && (typeof window < "u" || typeof x > "u" || (x.navigator = {
          userAgent: t,
          getUserMedia: function() {
          }
        }, x.console || (x.console = {}), (typeof x.console.log > "u" || typeof x.console.error > "u") && (x.console.error = x.console.log = x.console.log || function() {
          console.log(arguments);
        }), typeof document > "u" && (n.document = {
          documentElement: {
            appendChild: function() {
              return "";
            }
          }
        }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
          var u = {
            getContext: function() {
              return u;
            },
            play: function() {
            },
            pause: function() {
            },
            drawImage: function() {
            },
            toDataURL: function() {
              return "";
            },
            style: {}
          };
          return u;
        }, n.HTMLVideoElement = function() {
        }), typeof location > "u" && (n.location = {
          protocol: "file:",
          href: "",
          hash: ""
        }), typeof screen > "u" && (n.screen = {
          width: 0,
          height: 0
        }), typeof b > "u" && (n.URL = {
          createObjectURL: function() {
            return "";
          },
          revokeObjectURL: function() {
            return "";
          }
        }), n.window = x));
      })(typeof x < "u" ? x : null), e = e || "multi-streams-mixer";
      var a = [], s = !1, d = document.createElement("canvas"), f = d.getContext("2d");
      d.style.opacity = 0, d.style.position = "absolute", d.style.zIndex = -1, d.style.top = "-1000em", d.style.left = "-1000em", d.className = e, (document.body || document.documentElement).appendChild(d), this.disableLogs = !1, this.frameInterval = 10, this.width = 360, this.height = 240, this.useGainNode = !0;
      var r = this, h = window.AudioContext;
      typeof h > "u" && (typeof webkitAudioContext < "u" && (h = webkitAudioContext), typeof mozAudioContext < "u" && (h = mozAudioContext));
      var b = window.URL;
      typeof b > "u" && typeof webkitURL < "u" && (b = webkitURL), typeof navigator < "u" && typeof navigator.getUserMedia > "u" && (typeof navigator.webkitGetUserMedia < "u" && (navigator.getUserMedia = navigator.webkitGetUserMedia), typeof navigator.mozGetUserMedia < "u" && (navigator.getUserMedia = navigator.mozGetUserMedia));
      var c = window.MediaStream;
      typeof c > "u" && typeof webkitMediaStream < "u" && (c = webkitMediaStream), typeof c < "u" && typeof c.prototype.stop > "u" && (c.prototype.stop = function() {
        this.getTracks().forEach(function(n) {
          n.stop();
        });
      });
      var g = {};
      typeof h < "u" ? g.AudioContext = h : typeof webkitAudioContext < "u" && (g.AudioContext = webkitAudioContext);
      function p(n, u) {
        "srcObject" in u ? u.srcObject = n : "mozSrcObject" in u ? u.mozSrcObject = n : u.srcObject = n;
      }
      this.startDrawingFrames = function() {
        m();
      };
      function m() {
        if (!s) {
          var n = a.length, u = !1, w = [];
          if (a.forEach(function(L) {
            L.stream || (L.stream = {}), L.stream.fullcanvas ? u = L : w.push(L);
          }), u)
            d.width = u.stream.width, d.height = u.stream.height;
          else if (w.length) {
            d.width = n > 1 ? w[0].width * 2 : w[0].width;
            var y = 1;
            (n === 3 || n === 4) && (y = 2), (n === 5 || n === 6) && (y = 3), (n === 7 || n === 8) && (y = 4), (n === 9 || n === 10) && (y = 5), d.height = w[0].height * y;
          } else
            d.width = r.width || 360, d.height = r.height || 240;
          u && u instanceof HTMLVideoElement && l(u), w.forEach(function(L, S) {
            l(L, S);
          }), setTimeout(m, r.frameInterval);
        }
      }
      function l(n, u) {
        if (!s) {
          var w = 0, y = 0, L = n.width, S = n.height;
          u === 1 && (w = n.width), u === 2 && (y = n.height), u === 3 && (w = n.width, y = n.height), u === 4 && (y = n.height * 2), u === 5 && (w = n.width, y = n.height * 2), u === 6 && (y = n.height * 3), u === 7 && (w = n.width, y = n.height * 3), typeof n.stream.left < "u" && (w = n.stream.left), typeof n.stream.top < "u" && (y = n.stream.top), typeof n.stream.width < "u" && (L = n.stream.width), typeof n.stream.height < "u" && (S = n.stream.height), f.drawImage(n, w, y, L, S), typeof n.stream.onRender == "function" && n.stream.onRender(f, w, y, L, S, u);
        }
      }
      function T() {
        s = !1;
        var n = k(), u = o();
        return u && u.getTracks().filter(function(w) {
          return w.kind === "audio";
        }).forEach(function(w) {
          n.addTrack(w);
        }), i.forEach(function(w) {
          w.fullcanvas;
        }), n;
      }
      function k() {
        C();
        var n;
        "captureStream" in d ? n = d.captureStream() : "mozCaptureStream" in d ? n = d.mozCaptureStream() : r.disableLogs || console.error("Upgrade to latest Chrome or otherwise enable this flag: chrome://flags/#enable-experimental-web-platform-features");
        var u = new c();
        return n.getTracks().filter(function(w) {
          return w.kind === "video";
        }).forEach(function(w) {
          u.addTrack(w);
        }), d.stream = u, u;
      }
      function o() {
        g.AudioContextConstructor || (g.AudioContextConstructor = new g.AudioContext()), r.audioContext = g.AudioContextConstructor, r.audioSources = [], r.useGainNode === !0 && (r.gainNode = r.audioContext.createGain(), r.gainNode.connect(r.audioContext.destination), r.gainNode.gain.value = 0);
        var n = 0;
        if (i.forEach(function(u) {
          if (u.getTracks().filter(function(y) {
            return y.kind === "audio";
          }).length) {
            n++;
            var w = r.audioContext.createMediaStreamSource(u);
            r.useGainNode === !0 && w.connect(r.gainNode), r.audioSources.push(w);
          }
        }), !!n)
          return r.audioDestination = r.audioContext.createMediaStreamDestination(), r.audioSources.forEach(function(u) {
            u.connect(r.audioDestination);
          }), r.audioDestination.stream;
      }
      function v(n) {
        var u = document.createElement("video");
        return p(n, u), u.className = e, u.muted = !0, u.volume = 0, u.width = n.width || r.width || 360, u.height = n.height || r.height || 240, u.play(), u;
      }
      this.appendStreams = function(n) {
        if (!n)
          throw "First parameter is required.";
        n instanceof Array || (n = [n]), n.forEach(function(u) {
          var w = new c();
          if (u.getTracks().filter(function(S) {
            return S.kind === "video";
          }).length) {
            var y = v(u);
            y.stream = u, a.push(y), w.addTrack(u.getTracks().filter(function(S) {
              return S.kind === "video";
            })[0]);
          }
          if (u.getTracks().filter(function(S) {
            return S.kind === "audio";
          }).length) {
            var L = r.audioContext.createMediaStreamSource(u);
            r.audioDestination = r.audioContext.createMediaStreamDestination(), L.connect(r.audioDestination), w.addTrack(r.audioDestination.stream.getTracks().filter(function(S) {
              return S.kind === "audio";
            })[0]);
          }
          i.push(w);
        });
      }, this.releaseStreams = function() {
        a = [], s = !0, r.gainNode && (r.gainNode.disconnect(), r.gainNode = null), r.audioSources.length && (r.audioSources.forEach(function(n) {
          n.disconnect();
        }), r.audioSources = []), r.audioDestination && (r.audioDestination.disconnect(), r.audioDestination = null), r.audioContext && r.audioContext.close(), r.audioContext = null, f.clearRect(0, 0, d.width, d.height), d.stream && (d.stream.stop(), d.stream = null);
      }, this.resetVideoStreams = function(n) {
        n && !(n instanceof Array) && (n = [n]), C(n);
      };
      function C(n) {
        a = [], n = n || i, n.forEach(function(u) {
          if (u.getTracks().filter(function(y) {
            return y.kind === "video";
          }).length) {
            var w = v(u);
            w.stream = u, a.push(w);
          }
        });
      }
      this.name = "MultiStreamsMixer", this.toString = function() {
        return this.name;
      }, this.getMixedStream = T;
    }
    typeof R > "u" && (Se.exports = Be);
    /**
     * MultiStreamRecorder can record multiple videos in single container.
     * @summary Multi-videos recorder.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef MultiStreamRecorder
     * @class
     * @example
     * var options = {
     *     mimeType: 'video/webm'
     * }
     * var recorder = new MultiStreamRecorder(ArrayOfMediaStreams, options);
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     *
     *     // or
     *     var blob = recorder.blob;
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStreams} mediaStreams - Array of MediaStreams.
     * @param {object} config - {disableLogs:true, frameInterval: 1, mimeType: "video/webm"}
     */
    function Ue(i, e) {
      i = i || [];
      var t = this, a, s;
      e = e || {
        elementClass: "multi-streams-mixer",
        mimeType: "video/webm",
        video: {
          width: 360,
          height: 240
        }
      }, e.frameInterval || (e.frameInterval = 10), e.video || (e.video = {}), e.video.width || (e.video.width = 360), e.video.height || (e.video.height = 240), this.record = function() {
        a = new Be(i, e.elementClass || "multi-streams-mixer"), d().length && (a.frameInterval = e.frameInterval || 10, a.width = e.video.width || 360, a.height = e.video.height || 240, a.startDrawingFrames()), e.previewStream && typeof e.previewStream == "function" && e.previewStream(a.getMixedStream()), s = new P(a.getMixedStream(), e), s.record();
      };
      function d() {
        var f = [];
        return i.forEach(function(r) {
          A(r, "video").forEach(function(h) {
            f.push(h);
          });
        }), f;
      }
      this.stop = function(f) {
        s && s.stop(function(r) {
          t.blob = r, f(r), t.clearRecordedData();
        });
      }, this.pause = function() {
        s && s.pause();
      }, this.resume = function() {
        s && s.resume();
      }, this.clearRecordedData = function() {
        s && (s.clearRecordedData(), s = null), a && (a.releaseStreams(), a = null);
      }, this.addStreams = function(f) {
        if (!f)
          throw "First parameter is required.";
        f instanceof Array || (f = [f]), i.concat(f), !(!s || !a) && (a.appendStreams(f), e.previewStream && typeof e.previewStream == "function" && e.previewStream(a.getMixedStream()));
      }, this.resetVideoStreams = function(f) {
        a && (f && !(f instanceof Array) && (f = [f]), a.resetVideoStreams(f));
      }, this.getMixer = function() {
        return a;
      }, this.name = "MultiStreamRecorder", this.toString = function() {
        return this.name;
      };
    }
    typeof R < "u" && (R.MultiStreamRecorder = Ue);
    /**
     * RecordRTCPromisesHandler adds promises support in {@link RecordRTC}. Try a {@link https://github.com/muaz-khan/RecordRTC/blob/master/simple-demos/RecordRTCPromisesHandler.html|demo here}
     * @summary Promises for {@link RecordRTC}
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef RecordRTCPromisesHandler
     * @class
     * @example
     * var recorder = new RecordRTCPromisesHandler(mediaStream, options);
     * recorder.startRecording()
     *         .then(successCB)
     *         .catch(errorCB);
     * // Note: You can access all RecordRTC API using "recorder.recordRTC" e.g. 
     * recorder.recordRTC.onStateChanged = function(state) {};
     * recorder.recordRTC.setRecordingDuration(5000);
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
     * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
     * @throws Will throw an error if "new" keyword is not used to initiate "RecordRTCPromisesHandler". Also throws error if first argument "MediaStream" is missing.
     * @requires {@link RecordRTC}
     */
    function ze(i, e) {
      if (!this)
        throw 'Use "new RecordRTCPromisesHandler()"';
      if (typeof i > "u")
        throw 'First argument "MediaStream" is required.';
      var t = this;
      t.recordRTC = new R(i, e), this.startRecording = function() {
        return new Promise(function(a, s) {
          try {
            t.recordRTC.startRecording(), a();
          } catch (d) {
            s(d);
          }
        });
      }, this.stopRecording = function() {
        return new Promise(function(a, s) {
          try {
            t.recordRTC.stopRecording(function(d) {
              if (t.blob = t.recordRTC.getBlob(), !t.blob || !t.blob.size) {
                s("Empty blob.", t.blob);
                return;
              }
              a(d);
            });
          } catch (d) {
            s(d);
          }
        });
      }, this.pauseRecording = function() {
        return new Promise(function(a, s) {
          try {
            t.recordRTC.pauseRecording(), a();
          } catch (d) {
            s(d);
          }
        });
      }, this.resumeRecording = function() {
        return new Promise(function(a, s) {
          try {
            t.recordRTC.resumeRecording(), a();
          } catch (d) {
            s(d);
          }
        });
      }, this.getDataURL = function(a) {
        return new Promise(function(s, d) {
          try {
            t.recordRTC.getDataURL(function(f) {
              s(f);
            });
          } catch (f) {
            d(f);
          }
        });
      }, this.getBlob = function() {
        return new Promise(function(a, s) {
          try {
            a(t.recordRTC.getBlob());
          } catch (d) {
            s(d);
          }
        });
      }, this.getInternalRecorder = function() {
        return new Promise(function(a, s) {
          try {
            a(t.recordRTC.getInternalRecorder());
          } catch (d) {
            s(d);
          }
        });
      }, this.reset = function() {
        return new Promise(function(a, s) {
          try {
            a(t.recordRTC.reset());
          } catch (d) {
            s(d);
          }
        });
      }, this.destroy = function() {
        return new Promise(function(a, s) {
          try {
            a(t.recordRTC.destroy());
          } catch (d) {
            s(d);
          }
        });
      }, this.getState = function() {
        return new Promise(function(a, s) {
          try {
            a(t.recordRTC.getState());
          } catch (d) {
            s(d);
          }
        });
      }, this.blob = null, this.version = "5.6.2";
    }
    typeof R < "u" && (R.RecordRTCPromisesHandler = ze);
    /**
     * WebAssemblyRecorder lets you create webm videos in JavaScript via WebAssembly. The library consumes raw RGBA32 buffers (4 bytes per pixel) and turns them into a webm video with the given framerate and quality. This makes it compatible out-of-the-box with ImageData from a CANVAS. With realtime mode you can also use webm-wasm for streaming webm videos.
     * @summary Video recording feature in Chrome, Firefox and maybe Edge.
     * @license {@link https://github.com/muaz-khan/RecordRTC/blob/master/LICENSE|MIT}
     * @author {@link https://MuazKhan.com|Muaz Khan}
     * @typedef WebAssemblyRecorder
     * @class
     * @example
     * var recorder = new WebAssemblyRecorder(mediaStream);
     * recorder.record();
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
     * @param {object} config - {webAssemblyPath:'webm-wasm.wasm',workerPath: 'webm-worker.js', frameRate: 30, width: 1920, height: 1080, bitrate: 1024, realtime: true}
     */
    function re(i, e) {
      (typeof ReadableStream > "u" || typeof WritableStream > "u") && console.error("Following polyfill is strongly recommended: https://unpkg.com/@mattiasbuelens/web-streams-polyfill/dist/polyfill.min.js"), e = e || {}, e.width = e.width || 640, e.height = e.height || 480, e.frameRate = e.frameRate || 30, e.bitrate = e.bitrate || 1200, e.realtime = e.realtime || !0;
      var t;
      function a() {
        return new ReadableStream({
          start: function(b) {
            var c = document.createElement("canvas"), g = document.createElement("video"), p = !0;
            g.srcObject = i, g.muted = !0, g.height = e.height, g.width = e.width, g.volume = 0, g.onplaying = function() {
              c.width = e.width, c.height = e.height;
              var m = c.getContext("2d"), l = 1e3 / e.frameRate, T = setInterval(function() {
                if (t && (clearInterval(T), b.close()), p && (p = !1, e.onVideoProcessStarted && e.onVideoProcessStarted()), m.drawImage(g, 0, 0), b._controlledReadableStream.state !== "closed")
                  try {
                    b.enqueue(
                      m.getImageData(0, 0, e.width, e.height)
                    );
                  } catch {
                  }
              }, l);
            }, g.play();
          }
        });
      }
      var s;
      function d(b, c) {
        if (!e.workerPath && !c) {
          t = !1, fetch(
            "https://unpkg.com/webm-wasm@latest/dist/webm-worker.js"
          ).then(function(p) {
            p.arrayBuffer().then(function(m) {
              d(b, m);
            });
          });
          return;
        }
        if (!e.workerPath && c instanceof ArrayBuffer) {
          var g = new Blob([c], {
            type: "text/javascript"
          });
          e.workerPath = B.createObjectURL(g);
        }
        e.workerPath || console.error("workerPath parameter is missing."), s = new Worker(e.workerPath), s.postMessage(e.webAssemblyPath || "https://unpkg.com/webm-wasm@latest/dist/webm-wasm.wasm"), s.addEventListener("message", function(p) {
          p.data === "READY" ? (s.postMessage({
            width: e.width,
            height: e.height,
            bitrate: e.bitrate || 1200,
            timebaseDen: e.frameRate || 30,
            realtime: e.realtime
          }), a().pipeTo(new WritableStream({
            write: function(m) {
              if (t) {
                console.error("Got image, but recorder is finished!");
                return;
              }
              s.postMessage(m.data.buffer, [m.data.buffer]);
            }
          }))) : p.data && (f || h.push(p.data));
        });
      }
      this.record = function() {
        h = [], f = !1, this.blob = null, d(i), typeof e.initCallback == "function" && e.initCallback();
      };
      var f;
      this.pause = function() {
        f = !0;
      }, this.resume = function() {
        f = !1;
      };
      function r(b) {
        if (!s) {
          b && b();
          return;
        }
        s.addEventListener("message", function(c) {
          c.data === null && (s.terminate(), s = null, b && b());
        }), s.postMessage(null);
      }
      var h = [];
      this.stop = function(b) {
        t = !0;
        var c = this;
        r(function() {
          c.blob = new Blob(h, {
            type: "video/webm"
          }), b(c.blob);
        });
      }, this.name = "WebAssemblyRecorder", this.toString = function() {
        return this.name;
      }, this.clearRecordedData = function() {
        h = [], f = !1, this.blob = null;
      }, this.blob = null;
    }
    typeof R < "u" && (R.WebAssemblyRecorder = re);
  }(Te)), Te.exports;
}
var $e = Ye();
const Qe = /* @__PURE__ */ Je($e), Ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qe
}, Symbol.toStringTag, { value: "Module" }));
export {
  Ze as RecordRTC
};
//# sourceMappingURL=RecordRTC-BhQBmu42.js.map
